module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-page"
  }, [_c('section', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("About")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "about-inner"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon.svg")
    }
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Corporate Mailing Address")]), _c('br'), _vm._v("\n              Production Locations, Inc"), _c('br'), _vm._v("\n              9663 Santa Monica Blvd. #490"), _c('br'), _vm._v("\n              Beverly Hills, CA 90210\n           ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Downtown Office")]), _c('br'), _vm._v("\n              756 S Broadway #1110"), _c('br'), _vm._v("\n              Los Angeles, CA 90014\n           ")]), _vm._v(" "), _c('p', [_vm._v("\n              P 323.874.0404"), _c('br'), _vm._v("\n              F 323.843.9808\n           ")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h2', [_vm._v("We are a group of hard-working media fanatics who find awesome locations for some of the best-known TV shows, commercials, music videos, and feature films.")]), _vm._v(" "), _c('p', [_vm._v("What began as a one-man operation in early 2006 has grown into a full-service agency dedicated to represent property owners and media production companies with on location filming, photography, and special events.")]), _vm._v(" "), _c('p', [_vm._v("We set about to develop a comprehensive and reliable industry resource by adopting new technologies that promote efficiency and accessibility while complementing our sustained traditional methods of good business practice and attentive client service.")]), _vm._v(" "), _c('p', [_vm._v("Utilizing a collective background in production, design, and photography enables us to continually expand our library of production locations that are available for filming use. If we don’t already have what you’re looking for, we will because we’re always scouting.")])]), _vm._v(" "), _c('div', {
    staticClass: "team"
  }, [_c('h2', [_vm._v("Our Team")]), _vm._v(" "), _c('div', {
    staticClass: "teammember"
  }, [_c('img', {
    attrs: {
      "src": "https://img.productionlocations.com/content/team/PL-Davidnew.jpg"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("David Hoover")]), _vm._v(" "), _c('p', [_vm._v("Senior Agent"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:david@productionlocations.com"
    }
  }, [_vm._v("david@productionlocations.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "teammember"
  }, [_c('img', {
    attrs: {
      "src": "https://img.productionlocations.com/content/team/PL-LaSharn.jpg"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("LaSharn Gilmer")]), _vm._v(" "), _c('p', [_vm._v("Site Rep"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:lasharn@productionlocations.com"
    }
  }, [_vm._v("lasharn@productionlocations.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "teammember"
  }, [_c('img', {
    attrs: {
      "src": "https://img.productionlocations.com/content/team/PL-Robnew.jpg"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Rob Johnson")]), _vm._v(" "), _c('p', [_vm._v("Senior Agent"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:rob@productionlocations.com"
    }
  }, [_vm._v("rob@productionlocations.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "teammember"
  }, [_c('img', {
    attrs: {
      "src": "https://img.productionlocations.com/content/team/PL-Josh.jpg"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Josh Colon")]), _vm._v(" "), _c('p', [_vm._v("Location Agent"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:josh@productionlocations.com"
    }
  }, [_vm._v("josh@productionlocations.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "teammember"
  }, [_c('img', {
    attrs: {
      "src": "https://img.productionlocations.com/content/team/PL-Shawn.jpg"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Shawn Fields")]), _vm._v(" "), _c('p', [_vm._v("Systems Administrator"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:shawn@productionlocations.com"
    }
  }, [_vm._v("shawn@productionlocations.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _c('div', {
    staticClass: "justifier"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-section"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6551936d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutPage.vue
// module id = 192
// module chunks = 1